import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { typeM } from 'src/app/Models/BasicForms/typeM';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-type-drawer',
  templateUrl: './type-drawer.component.html',
  styleUrls: ['./type-drawer.component.css']
})
export class TypeDrawerComponent implements OnInit {
  @Input() drawerClose: Function;
  @Input() data: typeM;

  constructor(public _apiService: ApiService, private notificationService: NzNotificationService) { }

  ngOnInit(): void { }

  close(typePage: NgForm) {
    this.drawerClose();
    this.reset(typePage);
  }

  reset(typePage: NgForm) {
    typePage.form.reset();
    this.data = new typeM();
  }

  isSpinning = false;
  logtext: string = "";
  save(addNew: boolean): void {
    var isOk = true;

    if (this.data.NAME != undefined) {
      if (this.data.NAME.trim() == '') {
        isOk = false;
        this.notificationService.error("Please Enter Valid Type", "");
      }
    } else {
      isOk = false;
      this.notificationService.error("Please Enter Valid Type", "");
    }

    if (this.data.ICON != undefined) {
      if (this.data.ICON.trim() == '') {
        isOk = false;
        this.notificationService.error("Please Enter Valid Icon Name", "");
      }
    } else {
      isOk = false;
      this.notificationService.error("Please Enter Valid Icon Name", "");
    }

    if (this.data.IS_ACTIVE == undefined) {
      isOk = false;
      this.notificationService.error("Please Select Type is Active or Not", "");
    }

    if (isOk) {
      this.isSpinning = true;

      if (!this.data.ID) {
        this._apiService.createType(this.data).subscribe(successCode => {


          if (successCode['code'] == "200") {
            this.notificationService.success("Type Added Successfully", "");

            if (!addNew) {
              this.drawerClose();
              this.isSpinning = false;

              this.logtext = 'Save & Close - Type Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Type Master ]";
              this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
                if (successCode['code'] == "200") {

                }
                else {

                }
              });

            } else {
              this.data = new typeM();

              this.logtext = 'Save & New - Type Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Type Master ]";
              this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
                if (successCode['code'] == "200") {

                }
                else {

                }
              });
            }
            this.isSpinning = false;

          } else {
            this.notificationService.error("Failed to Add Type", "");
            this.logtext = 'Save & Close - Type Master form - ERROR - ' + JSON.stringify(this.data) + " KEYWORD [C - Type Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });
          }

        }, err => {


          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        });

      } else {

        this._apiService.updateType(this.data).subscribe(successCode => {


          if (successCode['code'] == "200") {
            this.notificationService.success("Type Updated Successfully", "");
            this.logtext = 'Update & Close - Type Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Type Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });

            this.isSpinning = false;
            this.drawerClose();

          } else {
            this.notificationService.error("Failed to Update Type", "");
            this.logtext = 'Update & Close - Type Master form - ERROR - ' + JSON.stringify(this.data) + " KEYWORD [C - Type Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });
          }

        }, err => {


          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        });
      }
    }
  }
}
